import { render, staticRenderFns } from "./orderAgreement.vue?vue&type=template&id=5a3e720e&"
import script from "./orderAgreement.vue?vue&type=script&lang=js&"
export * from "./orderAgreement.vue?vue&type=script&lang=js&"
import style0 from "./orderAgreement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports